/* eslint-disable no-unused-vars */
/* eslint-disable prettier/prettier */
import { useRef } from 'react';
import MainProcessInstantaneousPowerComponent from '../../../common/layout/components/main.process.instantaneous.power.component';
import MachineStatusStackContainer from '../containers/machine.status.stack.container';
import MachineStatusProductionContainer from '../containers/machine.status.production.container';
import NewDashboardMainLayoutComponent from '../../../common/layout/components/new.dashboard.main.layout.component';
import MachineStatusFilterEquipmentsContainer from '../containers/machine.status.filter.equipments.container';
import MachineStatusTimelineContainer from '../containers/machine.status.timeline.container';
const routeExpand = new URLSearchParams(location.search).get('expand');
export default function MachineStatusDetailComponentNewDashboard({
  processDetails,
  setOpenMachineStatusSlider,
  selectEquipments,
  setSelectEquipments,
  setOpenEquipmentFilterSlider,
  openEquipmentFilterSlider,
  filterGraphId,
  setFilterGraphId,
  setFilterUpdate,
  filterUpdate,
  customizeUpdate
}) {
  const productionRef = useRef();
  const statusStackRef = useRef();
  const statusTimelineRef = useRef();
  const instantRef = useRef();
  const availableCharts = [
    {
      ref: productionRef,
      component: () => {
        return [
          MachineStatusProductionContainer,
          {
            ...processDetails,
            graphLabel: 'ms_production_percentage',
            setOpenMachineStatusSlider,
            setSelectEquipments,
            selectEquipments,
            openEquipmentFilterSlider,
            setOpenEquipmentFilterSlider,
            graphId: 1,
            setFilterGraphId,
            filterUpdate,
            customizeUpdate
          }
        ];
      },
      id: 'productionRef'
    },
  
    {
      ref: statusStackRef,
      component: () => {
        return [
          MachineStatusStackContainer,
          {
            ...processDetails,
            graphLabel: 'ms_equipment_status_percentage',
            setOpenMachineStatusSlider,
            setSelectEquipments,
            selectEquipments,
            openEquipmentFilterSlider,
            setOpenEquipmentFilterSlider,
            graphId: 2,
            setFilterGraphId,
            filterUpdate,
            customizeUpdate
          }
        ];
      },
      id: 'statusStack'
    },
    {
      ref: statusTimelineRef,
      component: () => {
        return [
            MachineStatusTimelineContainer,
          {
            ...processDetails,
            graphLabel: 'ms_equipment_status_timeline',
            openEquipmentFilterSlider,
            setOpenEquipmentFilterSlider,
            filterUpdate,
            setOpenMachineStatusSlider,
            setFilterGraphId,
            setFilterUpdate,
            graphId: 3,
            customizeUpdate

          }
        ];
      },
      id: 'statusTimeline'
    },
    {
      ref: instantRef,
      component: () => {
        return [
          MainProcessInstantaneousPowerComponent,
          {
            ...processDetails,
            graphLabel: 'equipment_instantaneous_power',
            four_layout: true,
           
          }
        ];
      },
      id: 'instantaneousProcess'
    }
  ];
  const selectedNames = processDetails?.graph_type || []; // e.g. ['Equipment status (%)', 'Production (%)']
  //console.log("selectedNames", selectedNames);
  
  // Filter chartWindows based on graph_name match
  const chartWindows = availableCharts.filter((c) => {
    const [_, config] = c.component();  // Destructure to get config
    return selectedNames.includes(config.graphLabel);
  });
  //console.log("Filtered chartWindows", chartWindows);
  
  return (
    <>
      <NewDashboardMainLayoutComponent chartWindows={chartWindows} routeExpand={routeExpand} />
      {openEquipmentFilterSlider && (
        <MachineStatusFilterEquipmentsContainer
          processDetails={processDetails}
          setOpenEquipmentFilterSlider={setOpenEquipmentFilterSlider}
          filterGraphId={filterGraphId}
          setFilterUpdate={setFilterUpdate}
        />
      )}
    </>
  );
}
